var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroubleshootBasicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 87,
    viewBox: "0 0 61 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_18143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9163 2.0734H4.08301C2.97844 2.0734 2.08301 2.96883 2.08301 4.0734V82.9266C2.08301 84.0312 2.97844 84.9266 4.08301 84.9266H56.9163C58.0209 84.9266 58.9163 84.0312 58.9163 82.9266V4.0734C58.9163 2.96883 58.0209 2.0734 56.9163 2.0734Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.666 23.5953H2.41602V30.5205H58.666V23.5953Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45801 43.2512H58.583",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20801 57.0601H31.1663",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20801 70.3713H31.1663",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.541 43.2512V85.0095",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_18143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshootBasicIcon);
export default __webpack_public_path__ + "static/media/troubleshoot_basic_icon.95b375b4cd2991c5e45ccfa2c4eeb5ea.svg";
export { ForwardRef as ReactComponent };